import React, { useState, useEffect, useContext } from 'react'
import { ThemeProvider, createTheme } from '@mui/material';
import MaterialTable from 'material-table';

import "./itMeetings.css";

// ---------------------------------------------------------------------Http Methods--------------------------------------------------------------------------------
import { Url } from '../../../../constants/ApiUrlConstants';
import { GET, DELETE } from '../../../Common/HttpMethods/HttpMethods';
// ---------------------------------------------------------------------Context Data--------------------------------------------------------------------------------
import { contextData } from '../../../../context/ContextProvider'

// ---------------------------------------------------------------------React Icons--------------------------------------------------------------------------------
import { BsEye } from "react-icons/bs";
import { SlPencil } from "react-icons/sl";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { BsDownload } from 'react-icons/bs'
import FailModal from '../../../Common/Popups/FailModal';
import SuccessModal from '../../../Common/Popups/SuccessModal';
import { FaCheckCircle } from "react-icons/fa";
import { IoIosShareAlt } from "react-icons/io";
import { Cuurent_EMAIL, Cuurent_RBAC_roles, FacilityTableRow, GeneratePDF, firstLineTextFromHtml, getAllToFromOptionalEmailArr, getColumns } from '../../../CommonCase/CommonFunctions';


export const getMeetingData1 = async ({
  selectedFromDate,
  selectedToDate,
  setLoading,
  setData1,
  setDataCopy1,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  token1
}) => {
  try {
    setLoading(true);
    let fromDate1 = moment(selectedFromDate).format('YYYY-MM-DD');
    let toDate1 = moment(selectedToDate).format('YYYY-MM-DD');

    const meetingResponse1 = await GET(
      Url.getMeetingsByTagAndRec
        .replace("{startDate}", `${fromDate1}`)
        .replace("{endDate}", `${toDate1}`)
        .replace("{deptTagId}", "3"),
      token1
    );

    if (meetingResponse1?.SUCCESS) {
      const IndexedData1 = meetingResponse1?.DATA?.scheduleMeeting.map((i, ind) => {
        return { ...i, index: ind + 1 };
      });
      setData1(IndexedData1);
      setDataCopy1(IndexedData1);
      setLoading(false);
    } else if (meetingResponse1?.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (meetingResponse1?.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (meetingResponse1?.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (meetingResponse1?.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (meetingResponse1?.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setFailMessage("Failed to fetch meetings.");
      setOpenFailModal(true);
    }
  } catch (error) {
    setLoading(false);
    setFailMessage("Failed to fetch meetings.");
    setOpenFailModal(true);
  }
};



export const handleDeleteMeeting = async ({
  setOpenWarningModal,
  setLoading,
  DELETE,
  Url,
  meetingIdToDelete,
  token1,
  getMeetingData1,
  selectedFromDate,
  selectedToDate,
  setData1,
  setDataCopy1,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  setSuccessMessage,
  setOpenSuccessModal,
}) => {
  setOpenWarningModal(false);

  try {
    setLoading(true);

    const deleteMeetingResp = await DELETE(Url.deleteMeeting.replace("{mid}", `${meetingIdToDelete}`), token1);

    if (deleteMeetingResp.SUCCESS) {
      await getMeetingData1({
        selectedFromDate,
  selectedToDate,
  setLoading,
  setData1,
  setDataCopy1,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  token1
      });

      setLoading(false);
      setSuccessMessage("Meeting deleted successfully.");
      setOpenSuccessModal(true);
    } else if (deleteMeetingResp?.STATUS === 401) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }else if (deleteMeetingResp?.STATUS === 400) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }else if (deleteMeetingResp?.STATUS === 403) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }else if (deleteMeetingResp?.STATUS === 404) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }else if (deleteMeetingResp?.STATUS === 500) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    } else {
      setLoading(false);
      setFailMessage("Failed to delete meeting.");
      setOpenFailModal(true);
    }
  } catch (error) {
    setLoading(false);
    setFailMessage("Failed to delete meeting.");
    setOpenFailModal(true);
  }
};

export const handleCloseFailModel = (setOpenFailModal) => {
  setOpenFailModal(false);
}

export const handleCloseSuccessModal = (setOpenSuccessModal) => {
  setOpenSuccessModal(false);
}

export const handleSessionExpClose = (navigate,setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
}

export const handleSearch = (inp,setData1,dataCopy1) => {
  setData1(dataCopy1?.filter((elem) => {
    return elem?.meetingSubject?.toLowerCase().includes(inp?.toLowerCase())
  }));
}

export const handleEditPast = (id,navigate) => {
  navigate("/main/meetings/edit-past-meeting", { state: { meetingId: id } });
}
export var usermail1 = Cuurent_EMAIL(); ;

export  const handleEditAccess = (props, navigate) => {
  const { allFullNamesArr, allEmailIdArr } = getAllToFromOptionalEmailArr(props?.participantsList);
  if (allEmailIdArr?.includes(usermail1)) {
    handleEditPast(props?.mid,navigate)
  }
}



const ItMeegings = ({ selectedToDate, selectedFromDate, tableIcons, searchInp, selectedPeriod }) => {

  const theme = createTheme();
  const token1 = sessionStorage.getItem("TOKEN");
  const { setViewPastMeeting, setLoading, setActive } = useContext(contextData);
  const navigate = useNavigate();
  // ---------------------------------------------------------------------------Popup Utility----------------------------------------------------------------------
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)
  const [openFailModal, setOpenFailModal] = useState(false);
  const [failMessage1, setFailMessage] = useState("");
  const [openWarningModal, setOpenWarningModal] = useState(false);
  // const handleCloseFailModel = () => {
  //   setOpenFailModal(false);
  // }
  // const handleCloseSuccessModal = () => {
  //   setOpenSuccessModal(false);
  // }

  // const handleSessionExpClose = () => {
  //   sessionStorage.clear();
  //   navigate('/login');
  //   setActive('tab1');
  // }

  // rbac1 roles
  let rrbac = Cuurent_RBAC_roles();
  const storedRbacRoles1 = JSON.parse(rrbac);
  const userRole1 = sessionStorage.getItem("USER")

  const [rbac1, setRbac1] = useState({});

  useEffect(() => {
    if (userRole1 !== "USER") {
      const roleWithQMSDashboard1 = storedRbacRoles1?.find(role => role.useCase === "QMS Meetings Summary");
      if (roleWithQMSDashboard1) {
        setRbac1(roleWithQMSDashboard1);
      }
    }
  }, []);


  // ---------------------------------------------------------------------------Popup End-------------------------------------------------------------------------
  const [data1, setData1] = useState([]);
  const [dataCopy1, setDataCopy1] = useState([]);
  const [meetingIdToDelete, setMeetingIdToDelete] = useState(null);


  // rbac roles
  // const storedRbacRoles = JSON.parse(rrbac);
  // const userRole = sessionStorage.getItem("USER")

  // const [rbac, setRbac] = useState({});

  // useEffect(() => {
  //   if (userRole !== "USER") {
  //     const roleWithQMSDashboard = storedRbacRoles?.find(role => role.useCase === "QMS Meetings Summary");
  //     if (roleWithQMSDashboard) {
  //       setRbac(roleWithQMSDashboard);
  //     }
  //   }
  // }, [userRole, storedRbacRoles]);


  useEffect(() => {
    getMeetingData1({
      selectedFromDate,
  selectedToDate,
  setLoading,
  setData1,
  setDataCopy1,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  token1
    });
  }, [selectedFromDate, selectedToDate]);

  useEffect(() => {
    handleSearch(searchInp,setData1,dataCopy1);
  }, [searchInp]);

  // const handleSearch = (inp) => {
  //   setData1(dataCopy1?.filter((elem) => {
  //     return elem?.meetingSubject?.toLowerCase().includes(inp?.toLowerCase())
  //   })
  //   )
  // };


  // const handleDeletePermission = (id) => {
  //   setMeetingIdToDelete(id)
  //   setFailMessage("Are you sure you want to delete meeting?");
  //   setOpenWarningModal(true);
  // }

  


 

  // const handleEditPast = (id) => {
  //   navigate("/main/meetings/edit-past-meeting", { state: { meetingId: id } });
  // }

  useEffect(() => {
    const text = document.getElementsByClassName("MuiTablePagination-selectLabel");
    [...text][0].innerHTML = "Show Entries";
    [...text][0].style.fontSize = "13px"
  }, [])


  const titleStyle = {
    borderRight: '1px solid gray',
  }
  const dataStyle = {
    borderRight: '1px solid black',
    // fontWeight: "600",
    color: "black",
  }

  const headStyle = {
    borderRight: "1px solid #b8b8b8",
    padding: "0px 6px",
    whiteSpace: "nowrap"
  }


  const Hr_backgroundColor = "#4CB87C";
  const DeptType = "It";


  const columns = getColumns(headStyle, titleStyle, dataStyle, usermail1, rbac1, setViewPastMeeting, handleEditAccess, Hr_backgroundColor, DeptType, navigate);






  const tableHeaderStyle = {
    backgroundColor: '#C4FFE4',
    color: "#1CA566",
    fontWeight: "bold",
    height: 20
  };


  return (
    <div className="IT-table-container" style={{ marginTop: "10px" }}>
      <ThemeProvider theme={theme}>
        <MaterialTable
          localization={{ body: { emptyDataSourceMessage: <span className="no_data_found_table">No Records to show</span> } }}
          data={data1}
          columns={columns}
          icons={tableIcons}
          options={{
            // showTitle:false,
            toolbar: false,
            // headerStyle: tableHeaderStyle,
            search: false,
            draggable: false,
            pageSizeOptions: [5, 10, 15, 20],
            pageSize: 10,
            headerStyle: {
              position: 'sticky',
              top: -1,
              ...tableHeaderStyle
            },
            maxBodyHeight: '57vh',
            minBodyHeight: '57vh'
            // maxBodyHeight: 'calc(100vh - 265px)',

          }}
        />
      </ThemeProvider>
      {/* ---------------------------------------------------------------------------Popups--------------------------------------------------------------------------------- */}
      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        recallFunctionOnOk={()=>handleCloseSuccessModal(setOpenSuccessModal)}
        recallFunctiononClose={()=>handleCloseSuccessModal(setOpenSuccessModal)}
      />
      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage1={failMessage1}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleCloseFailModel(setOpenFailModal)}
        recallFunctiononClose={()=>handleCloseFailModel(setOpenFailModal)}
      />
      {/* warning modal */}
      <FailModal
        openFailModal={openWarningModal}
        setOpenFailModal={setOpenWarningModal}
        failMessage1={failMessage1}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() =>
          handleDeleteMeeting({
            setOpenWarningModal,
            setLoading,
            DELETE,
            Url,
            meetingIdToDelete,
            token1,
            getMeetingData1,
            selectedFromDate,
            selectedToDate,
            setData1,
            setDataCopy1,
            setSessionExpiredModal,
            setFailMessage,
            setOpenFailModal,
            setSuccessMessage,
            setOpenSuccessModal,
          })
        }
        recallFunctiononClose={()=>handleCloseFailModel(setOpenFailModal)}
      />

      {/* session expire modal  */}
      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage1={failMessage1}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleSessionExpClose((navigate,setActive))}
        recallFunctiononClose={()=>handleSessionExpClose((navigate,setActive))}
      />

    </div>
  )
}

export default ItMeegings